import globalEn from 'utils/locale/common/en.json';

export default function TranslationsEn() {
  return {
    ...globalEn,
  };
}
